import script from "./StartZahnNew.vue?vue&type=script&setup=true&lang=js"
export * from "./StartZahnNew.vue?vue&type=script&setup=true&lang=js"

import "./StartZahnNew.vue?vue&type=style&index=0&id=abea4da8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abea4da8"]])

export default __exports__